import { Component } from '@angular/core';

@Component({
    selector: 'sf-forbidden',
    imports: [],
    templateUrl: './forbidden.component.html',
    styleUrl: './forbidden.component.scss'
})
export class ForbiddenComponent {

}
